export const ImageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg'];

export const PdfExtensions = ['pdf'];

export const OfficeExtensions = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'];
